import * as React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { AppContext, AppContextType } from '../context/AppContext';
import { useMyself } from 'controller/CommonService';
import EntireLoadingPage from 'components/ui/EntireLoadingPage';
import { useHttpClient } from 'hooks';
import { MappedEntityType, Entity } from 'services/resolvers';

export const AuthGuard = ({ children }: { children: React.ReactNode | null }): React.ReactElement => {
    const { asyncDetachedRequest: getPermissions } = useHttpClient<Record<string, string | boolean | number>>(
        Entity.Generic,
        MappedEntityType.GetPermissions,
        {}
    );
    const {
        isLoggedIn,
        setAppToken,
        propertyManager: { loaded, setProperties, resetProperties }
    } = React.useContext(AppContext) as AppContextType;
    const navigate = useNavigate();
    useMyself();

    React.useEffect(() => {
        if (!isLoggedIn) {
            resetProperties();
            navigate('login', { replace: true });
        } else if (!loaded) {
            getPermissions({}).then((permissions) => {
                if (permissions) {
                    setProperties(permissions);
                } else {
                    resetProperties();
                    setAppToken(undefined);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, navigate]);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    // return <>{children}</>;
    // SUPER IMPORTANT, NEVER SHOW THE CHILDREN UNTIL THE PROPERTY MANAGER IS LOADED
    return <>{!loaded ? <EntireLoadingPage /> : <>{children}</>}</>;
};

export const GuestGuard = (): React.ReactElement => {
    const { isLoggedIn } = React.useContext(AppContext) as AppContextType;
    const navigate = useNavigate();

    React.useEffect(() => {
        if (isLoggedIn) {
            navigate('', { replace: true });
        }
    }, [isLoggedIn, navigate]);

    return <Outlet />;
};
